// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ProfessionsModel from '../../model/professions-model';
import ProfessionsDTO from '../dto/professions-dto';
import dtoSchema from '../schemas/professions-schema';

export default abstract class ProfessionsModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ProfessionsDTO>) {
    super();
    if (data) {
      this.profession = data.profession ?? undefined;
      this.category = data.category ?? undefined;
      this.colorHex = data.colorHex ?? undefined;
    }
  }
  /**
  */
  profession?: string;
  /**
  */
  category?: string;
  /**
  */
  colorHex?: string;

  static toModel(dto: DeepPartial<ProfessionsDTO>): ProfessionsModel;
  static toModel(dto: DeepPartial<ProfessionsDTO> | undefined | null): ProfessionsModel | undefined;
  static toModel(dto: DeepPartial<ProfessionsDTO> | undefined | null): ProfessionsModel | undefined {
    return dto ? new ProfessionsModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ProfessionsModel> | ProfessionsModel): ProfessionsDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      profession: unwrapped.profession,
      category: unwrapped.category,
      colorHex: unwrapped.colorHex,
    } as ProfessionsDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ProfessionsModel, can not map to ProfessionsDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
